module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAABCAYAAAAB3PQ6AAAAEElEQVQImWP0cbT9z0AmAABn3gHLTORs2QAAAABJRU5ErkJggg=="